import { useSessionStore } from '@/stores/SessionStore.ts';
import { createTextToast } from '@/utils/ToastUtils.ts';

export const setTaskbarIconVisibilityAction = async (visible: boolean, showToast: boolean) => {
    if (!window.electronApi) {
        return;
    }

    const sessionStore = useSessionStore();
    sessionStore.isTaskbarIconVisible = visible;

    window.electronApi.setTaskbarIconVisibility(visible);

    if (showToast) {
        if (visible) {
            createTextToast(`Taskbar icon is now visible,`, undefined, 'default', true);
        } else {
            createTextToast(`Taskbar icon is now hidden.`, undefined, 'default', true);
        }
    }
};
